export { GenericBanner } from './GenericBanner'
